import { IButton } from './types';

export const addTagConfig: IButton = {
  icon: 'plus',
  variant: 'none',
  padding: 'none',
  title: 'Add tag',
  palette: 'primary',
};

export const deleteListItemConfig: IButton = {
  variant: 'none',
  title: 'Delete',
  padding: 'none',
  palette: 'primary',
};
